const styles = (theme) => ({
	// Titulo mais severo que os demais modais da feature - unico par completo (background/colorText.critical),
	// nunca mistura com outro par
	tituloSevero: {
		display: "flex",
		alignItems: "center",
		gap: 1,
		backgroundColor: theme.palette.chip.background.critical,
		color: theme.palette.chip.colorText.critical,
		fontWeight: 700,
	},
	subtitulo: {
		color: theme.palette.text.secondary,
		marginTop: "12px",
	},
	loadingContainer: {
		display: "flex",
		justifyContent: "center",
		padding: "24px",
	},
	textoPrincipal: {
		color: theme.palette.text.primary,
		marginTop: "12px",
	},
	// Aviso de falha ao checar divergencia - nao bloqueia o fluxo, so avisa
	avisoDivergenciaIndisponivel: {
		color: theme.palette.chip.colorText.critical,
		marginTop: "12px",
	},
	blocoAlerta: {
		display: "flex",
		flexDirection: "column",
		gap: 1,
		padding: "12px",
		borderRadius: "8px",
		backgroundColor: theme.palette.chip.background.critical,
		marginTop: "12px",
	},
	textoAlerta: {
		color: theme.palette.chip.colorText.critical,
		fontWeight: 600,
	},
	lista: {
		margin: 0,
		paddingLeft: "20px",
		maxHeight: "160px",
		overflowY: "auto",
	},
	itemListaAlerta: {
		fontSize: "0.85rem",
		color: theme.palette.chip.colorText.critical,
		wordBreak: "break-all",
	},
	semItens: {
		color: theme.palette.text.secondary,
	},
	confirmacaoContainer: {
		marginTop: "20px",
		display: "flex",
		flexDirection: "column",
		gap: 1,
	},
	textoConfirmacao: {
		color: theme.palette.text.primary,
		fontWeight: 600,
	},
	erro: {
		color: theme.palette.chip.colorText.critical,
		marginTop: "12px",
	},
	// Botao de confirmacao - mesmo par completo do titulo, sem mistura com outro token
	botaoForcar: {
		backgroundColor: theme.palette.chip.background.critical,
		color: theme.palette.chip.colorText.critical,
		fontWeight: 600,
		"&:hover": {
			backgroundColor: theme.palette.chip.background.critical,
			opacity: 0.85,
		},
		"&.Mui-disabled": {
			backgroundColor: theme.palette.chip.background.default,
			color: theme.palette.chip.colorText.default,
		},
	},
	resultadoContainer: {
		display: "flex",
		flexDirection: "column",
		gap: 1,
	},
	linhaResultado: {
		display: "flex",
		alignItems: "center",
		flexWrap: "wrap",
		gap: 1,
		padding: "8px 0px",
	},
	chip: {
		fontWeight: 600,
	},
	motivoResultado: {
		color: theme.palette.chip.colorText.critical,
		flexBasis: "100%",
	},
	versaoResultado: {
		color: theme.palette.text.secondary,
	},
});

export default styles;
